import { ControlledInput } from '../form-controls';
import { useForm } from 'react-hook-form';
import '../../pages/login/login-page.css';
import { QRCodeSVG } from 'qrcode.react';

export type SetupTOTPFormFields = {
  code: number;
};

type TOTPSetupDetails = {
  sharedSecret: string;
  setupUri: string;
};

interface SetupTOTPFormProps {
  onSubmit: (data: SetupTOTPFormFields) => void;
  onCancel?: () => void;
  totpSetupDetails: TOTPSetupDetails;
  error?: string; // Optional error property
}

export const SetupTOTPForm: React.FC<SetupTOTPFormProps> = ({
  onSubmit,
  onCancel,
  totpSetupDetails,
  error,
}) => {
  const { handleSubmit, control } = useForm<SetupTOTPFormFields>({});

  return (
    <form className="login-form" onSubmit={handleSubmit(onSubmit)}>
      <QRCodeSVG value={totpSetupDetails.setupUri} />
      <p className="totp-setup-text">{totpSetupDetails.sharedSecret}</p>
      <p className="totp-setup-text">
        Scan the QR code with your authenticator app or enter the code above manually.
      </p>

      <ControlledInput
        control={control}
        name="code"
        rules={{ required: true }}
        inputProps={{
          placeholder: 'TOTP Code',
          className: 'input-form',
          fullWidth: true,
          autoFocus: true,
        }}
      />
      {error && (
        <p className="error-message" role="alert">
          {error}
        </p>
      )}
      <button className="login-submit" type="submit">
        Login
      </button>
      {onCancel && (
        <button className="login-cancel" type="button" onClick={onCancel}>
          Back to login
        </button>
      )}
    </form>
  );
};
